/*=============================================== Modal context ===============================================*/

import { createContext, useState, useEffect } from "react"
import { disableScroll, enableScroll } from "tsx-library-julseb"

export type ModalContextType = {
    isModalOpen: boolean
    setIsModalOpen: (isModalOpen: boolean) => void
}

export const ModalContext = createContext<ModalContextType | null>(null)

export const ModalProviderWrapper = ({ children }: ModalProviderProps) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    useEffect(() => {
        if (isModalOpen) disableScroll()
        else enableScroll()
    }, [isModalOpen])

    return (
        <ModalContext.Provider value={{ isModalOpen, setIsModalOpen }}>
            {children}
        </ModalContext.Provider>
    )
}

interface ModalProviderProps {
    children?: any
}
